export default "__VITE_ASSET__BsodGPYR__"